module.exports = __webpack_public_path__ + "media/images/v2/header-background_optimized-1-23468c9a87fd72697b41b1d7fbf373c4.gif";